import { Routes, RouterModule } from '@angular/router';

//Route for content layout with sidebar, navbar and footer
export const Full_ROUTES: Routes = [
  {
    path: 'changelog',
    loadChildren: './changelog/changelog.module#ChangeLogModule'
  },
  {
    path: 'mapa',
    loadChildren: './pages/mapa/mapa.module#MapaModule'
  },
  {
    path: 'usuarios',
    loadChildren: './pages/full-layout-page/full-pages.module#FullPagesModule'
  },
  {
    path: 'relatorios',
    loadChildren: './pages/full-layout-page/full-pages.module#FullPagesModule'
  },
  {
    path: 'tros',
    loadChildren: './pages/full-layout-page/full-pages.module#FullPagesModule'
  },

  {
    path: 'perfis',
    loadChildren: './pages/full-layout-page/full-pages.module#FullPagesModule'
  },
  {
    path: 'permissoes',
    loadChildren: './pages/full-layout-page/full-pages.module#FullPagesModule'
  },
  {
    path: '',
    loadChildren: './pages/full-layout-page/full-pages.module#FullPagesModule'
  },

];



// WEBPACK FOOTER //
// ./src/app/shared/routes/full-layout.routes.ts